export enum FirstCheckState {
  AwaitingApproval,
  AwaitingUpload,
  Approved,
  Rejected,
}
